import type { BrokerOutreachCardDto } from "@/api/brokerOutreach";
import { useDateFormatter } from "@/utils/datetime";
import { isLoggedChannel } from "../introCards/introCardStatus";
import { sentByVia, writtenAsNote } from "./brokerOutreachCopy";

/**
 * A done Broker intro card's first body line (D3): "Sent {date} by {who} via
 * {app send | own email | copied text | web form}", or "Logged …" on the text
 * and web form — the details that used to sit in the header pill, which now
 * carries the one status (`IntroCardPill`). R13's "Written as …" follows when
 * the message was written as somebody other than who logged it.
 *
 * <p>The facts are the SERVER's (the latest send version), never inferred from
 * what is on screen.</p>
 */
export function CardSentLine({
  card,
  testId,
}: {
  card: Pick<BrokerOutreachCardDto, "channel" | "sentAtUtc" | "sentByName" | "sentVia" | "writtenAsName">;
  testId: string;
}) {
  const { date } = useDateFormatter();
  if (!card.sentAtUtc) return null;
  const verb = isLoggedChannel(card.channel) ? "Logged" : "Sent";
  const rest = sentByVia(card);
  const written = writtenAsNote(card);
  return (
    <p className="text-small text-onyx m-0" data-testid={testId}>
      {verb} {date(card.sentAtUtc)}
      {rest ? ` ${rest}` : ""}
      {written ? <span className="text-caption text-gray-mid"> · {written}</span> : null}
    </p>
  );
}
